'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function (angular) {
    "use strict";

    angular.module('dresden.common', []).constant('DataStoreUrl', "https://intense-fire-8692.firebaseio.com/DresdenFiles").factory("DataStore", ["$firebaseObject", 'DataStoreUrl', function ($firebaseObject, DataStoreUrl) {
        return {
            getCharsForUser: function getCharsForUser(uid) {
                var root = firebase.database().ref();
                var ref = root.child('DresdenFiles').child('chars');
                ref.orderByChild('uid').equalTo(uid);
                return $firebaseObject(ref);
            }
        };
    }]).factory("CharacterRef", ["$firebaseObject", 'DataStoreUrl', function ($firebaseObject, DataStoreUrl) {
        return function (name) {
            var root = firebase.database().ref();
            var ref = root.child('DresdenFiles').child('chars').child(name);
            return $firebaseObject(ref);
        };
    }]).factory("DataStore2", ["$q", "$firebaseObject", 'DataStoreUrl', function ($q, $firebaseObject, DataStoreUrl) {
        return {

            getUserData: function getUserData(uid) {

                var deferred = $q.defer();

                // var root = firebase.database().ref().child('DresdenFiles/users');
                // var users = $firebaseObject(root);
                // users.$loaded(function() {

                //     if(!users[uid]) {

                //         users[uid] = { chars: {} };
                //         users.$save().then(function() {
                //             deferred.resolve($firebaseObject(users[uid]));
                //         }, function(error) {
                //             deferred.reject(error);
                //         });  
                //     } else {
                //         deferred.resolve($firebaseObject(users[uid]));
                //     }

                // });

                var ref = firebase.database().ref().child('DresdenFiles/users/' + uid);
                var user = $firebaseObject(ref);
                user.$loaded(function () {
                    var exists = user.$value !== null;
                    if (exists) {
                        deferred.resolve(user);
                        return;
                    }

                    var root = firebase.database().ref().child('DresdenFiles/users');
                    root.child(uid).set({
                        chars: {},
                        uid: uid
                    });

                    user = $firebaseObject(root.child(uid));
                    deferred.resolve(user);
                });

                return deferred.promise;
            },

            getCharsForUser: function getCharsForUser(uid) {
                var ref = firebase.database().ref().child('DresdenFiles/users/' + uid + '/chars');
                return $firebaseObject(ref);
            },

            getCharacter: function getCharacter(uid, name) {
                var ref = firebase.database().ref().child('DresdenFiles/users/' + uid + '/chars/' + name);
                return $firebaseObject(ref);
            },

            createCharacter: function createCharacter(uid, character) {

                var ref = firebase.database().ref().child('DresdenFiles/users/' + uid + '/chars');
                ref.child(character.name).set(character);
                return $firebaseObject(ref.child(character.name));
            }
        };
    }]).filter('encode', function () {
        return function (value) {
            return encodeURIComponent(value);
        };
    }).filter('decode', function () {
        return function (value) {
            return decodeURIComponent(value);
        };
    }).provider('responsiveHelper', ["$windowProvider", function ($windowProvider) {

        var $window = $windowProvider.$get();

        function Helper($window) {
            this.window = $window;
        }
        Helper.prototype = {
            getWidth: function getWidth() {
                return $window.innerWidth || $window.outerWidth;
            },
            isXS: function isXS() {
                var width = this.getWidth();return width < 768;
            },
            isSM: function isSM() {
                var width = this.getWidth();return width >= 768 && width < 992;
            },
            isMD: function isMD() {
                var width = this.getWidth();return width >= 992 && width < 1200;
            },
            isLG: function isLG() {
                var width = this.getWidth();return width >= 1200;
            }
        };

        var helper = new Helper($window);

        this.$get = function () {
            return helper;
        };
    }])

    //directive which appends appropriate responsive breakpoint classNames to the element
    // on which it's set
    .directive('responsive', ['$window', 'responsiveHelper', function ($window, responsiveHelper) {

        return {
            restrict: "A",
            link: function link($scope, $element, $attrs) {

                function update(el, helper) {
                    if (helper.isXS()) el.addClass('responsive-xs');else el.removeClass('responsive-xs');

                    if (helper.isSM()) el.addClass('responsive-sm');else el.removeClass('responsive-sm');

                    if (helper.isMD()) el.addClass('responsive-md');else el.removeClass('responsive-md');

                    if (helper.isLG()) el.addClass('responsive-lg');else el.removeClass('responsive-lg');
                }

                update($element, responsiveHelper);

                var resizeFn = function resizeFn() {
                    update($element, responsiveHelper);
                };

                var w = angular.element($window);
                var listener = w.on('resize', resizeFn);

                $scope.$on('$destroy', function () {
                    w.off('resize', resizeFn);
                });
            }
        };
    }]).controller('KeyPad', function ($scope, $uibModalInstance, value, minimum, maximum) {

        $scope.value = value;
        $scope.minimum = minimum * 1 || 0;
        $scope.maximum = maximum * 1 || 9999;

        $scope.change = function (v) {
            if (v > 0) $scope.value = Math.min($scope.value + v, maximum);else $scope.value = Math.max($scope.value + v, minimum);
        };

        $scope.ok = function () {
            $uibModalInstance.close($scope.value);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }).directive('editableStatValue', ['$uibModal', function ($uibModal) {
        return {
            scope: {
                onSave: '&',
                minimum: '@',
                maximum: '@'
            },
            restrict: 'A',
            require: 'ngModel',
            replace: true,
            template: '<div class="value" ng-click="openKeypad()">{{display}}</div>',
            link: function link($scope, $element, $attrs, ngModelController) {

                $scope.minimum = ($scope.minimum || 0) * 1;
                $scope.maximum = ($scope.maximum || 9999) * 1;

                ngModelController.$render = function () {
                    $scope.display = ngModelController.$viewValue;
                };

                $scope.openKeypad = function () {

                    var _value = ngModelController.$modelValue || 0;

                    var modalInstance = $uibModal.open({
                        templateUrl: 'src/keypad.html',
                        controller: 'KeyPad',
                        animation: false,
                        resolve: {
                            value: function value() {
                                return _value;
                            },
                            minimum: function minimum() {
                                return $scope.minimum;
                            },
                            maximum: function maximum() {
                                return $scope.maximum;
                            }
                        }
                    });

                    modalInstance.result.then(function (value) {

                        ngModelController.$setViewValue(value);
                        ngModelController.$render();
                        if ($scope.onSave) $scope.onSave();
                    }, function () {});
                };
            }
        };
    }]).directive('editableInput', ['$timeout', function ($timeout) {

        return {
            restrict: 'AE',
            require: 'ngModel',
            scope: {
                label: "@",
                onSave: "&"
            },
            replace: true,
            template: ['<div class="editable-input">', '  <label class="editable-input-label">{{::label}}</label>', '  <span class="editable-input-display" ng-show="!editing" ng-click="edit()"></span>', '    <form class="form" ng-show="editing">', '      <div class="form-group">', '        <div class="grid">', '          <div class="grid__col-auto grid__col--grow-2">', '            <input type="text" class="form-control editable-input-field" ', '              ng-keyup="onKeyUp($event, $event.keyCode)"></input>', '          </div>', '          <div class="grid__col-auto">', '            <div class="editable-input-buttons">', '              <button type="button" class="btn btn-xs btn-link text-success" ng-disabled="error" ng-click="done()" tabindex="0">', '                <span class="glyphicon glyphicon-ok"></span>', '              </button>', '              <button type="button" class="btn btn-xs btn-link text-danger" ng-click="cancel()"  tabindex="0">', '                <span class="glyphicon glyphicon-remove"></span>', '              </button>', '            </div>', '          </div>', '        </div>', '      </div>', '    </form>', '</div>'].join(' '),

            link: function link($scope, $element, $attrs, ngModelController) {

                function update(newValue) {
                    // call $parsers pipeline then update $modelValue
                    ngModelController.$setViewValue(newValue);
                    // update the local view
                    ngModelController.$render();
                }

                // when model change, update our view (just update the div content)
                ngModelController.$render = function () {

                    var value = ngModelController.$viewValue;
                    var display = !value || !value.length || !value.trim().length ? "Please enter a value" : value;
                    $element.find('.editable-input-display').text(display);
                    $element.find('.editable-input-field').val(value);
                };

                /* ------------- private methods --------------- */

                $scope.edit = function () {
                    $scope.editing = true;
                    $timeout(function () {
                        $element.find('.editable-input-field').focus().select();
                    }, 200);
                };
                $scope.done = function () {
                    //update display with new value
                    var value = $element.find('.editable-input-field').val();
                    update(value);
                    $scope.editing = false;
                    $scope.onSave();
                };
                $scope.cancel = function () {
                    //reset input
                    $element.find('.editable-input-field').val(ngModelController.$viewValue);
                    $scope.editing = false;
                };

                $scope.onKeyUp = function ($event, code) {
                    // console.log("Up " + code);
                    if ((code === undefined || code === 0) && $event.which !== undefined) code = $event.which;
                    if (code === 13 && !$scope.error) $scope.done(); //enter
                    else if (code === 27) $scope.cancel(); //esc
                };
            }
        };
    }]).directive('imgSelector', function () {

        function base64(file, callback) {
            var coolFile = {};
            function readerOnload(e) {
                var base64 = btoa(e.target.result);
                coolFile.base64 = base64;
                callback(coolFile);
            };

            var reader = new FileReader();
            reader.onload = readerOnload;

            var file = file[0].files[0];
            if (file.size > 100000) {
                alert("Image is too large, should be less than 100 KB");
                callback(null);
                return;
            }

            coolFile.filetype = file.type;
            coolFile.size = file.size;
            coolFile.filename = file.name;
            reader.readAsBinaryString(file);
        }

        return {
            scope: {
                onSave: '&'
            },
            require: 'ngModel',
            template: ['<form class="img-selector">', '  <div class="image" title="click to change">', '    <img src="assets/avatar.png">', '  </div>', '  <button type="button" class="btn btn-sm btn-success" ', '    ng-if="imgData && isDirty()" ng-click="save()">save</button>', '  <input type="file" class="hidden">', '</form>'].join(' '),

            link: function link($scope, $element, $attrs, ngModelController) {

                $scope.isDirty = function () {
                    return ngModelController.$dirty;
                };

                function update() {
                    if (!$scope.imgData) {
                        return;
                    }
                    var image = '<img alt="avatar" src="' + $scope.imgData + '">';
                    $element.find('.image').html(image);
                }

                $scope.save = function () {
                    ngModelController.$setViewValue($scope.imgData);
                    ngModelController.$setPristine();
                    $scope.onSave();
                };

                function onFileSelect() {

                    console.log("selecting file");
                    base64($element.find('input'), function (data) {

                        if (!data) {
                            $element.find('form')[0].reset();
                            return;
                        }

                        $scope.$apply(function () {
                            $scope.imgData = 'data:' + data.filetype + ';base64,' + data.base64;
                            update();
                            ngModelController.$setDirty();
                        });
                    });
                }

                var filePicker = $element.find('input');
                $element.find('.image').on('click', function () {
                    filePicker.trigger('click');
                });
                filePicker.on('change', onFileSelect);

                ngModelController.$render = function () {
                    if (!$scope.imgData) {
                        $scope.imgData = ngModelController.$viewValue;
                        update();
                    }
                };
            }
        };
    }).controller('LoginController', function ($scope, $uibModalInstance, $timeout, Auth) {

        $timeout(function () {
            $('#email').focus();
        }, 500);

        $scope.onKeyUp = function ($event, code) {
            // console.log("Up " + code);
            if ((code === undefined || code === 0) && $event.which !== undefined) code = $event.which;
            if (code === 13 && //enter
            $scope.email && $scope.password) $scope.login();else if (code === 27) //esc   
                $scope.cancel();
        };

        $scope.login = function () {

            Auth.$signInWithEmailAndPassword($scope.email, $scope.password).then(function (authData) {
                // console.log("Logged in");
                $scope.errorMessage = null;
                $uibModalInstance.close();
            }).catch(function (error) {
                var errorCode = error.code;
                $scope.errorMessage = error.message;
                console.log("unable to login: " + $scope.errorMessage);
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }).component('login', {

        template: ['<a ng-if="!$ctrl.user" ng-click="$ctrl.doLogin()">Login</a>', '<a ng-if="$ctrl.user" class="dropdown-toggle" data-toggle="dropdown" ', '  role="button" aria-haspopup="true" aria-expanded="false">', '  <span class="hidden-xs">{{$ctrl.user.email}}</span> ', '  <span class="visible-xs-inline-block glyphicon glyphicon-user"></span>', '  <span class="caret"></span>', '</a>', '<ul ng-if="$ctrl.user" class="dropdown-menu">', '  <li><a ng-click="$ctrl.doReset()">Reset Password</a></li>', '  <li><a ng-click="$ctrl.doLogout()">Log out</a></li>', '</ul>', '</div>'].join(' '),

        controller: function controller($uibModal, $firebaseAuth) {
            var _this = this;

            this.$onInit = function () {
                _this.auth = $firebaseAuth();
                _this.auth.$onAuthStateChanged(function (authData) {
                    return _this.user = authData;
                });
            };

            this.$onDestroy = function () {
                _this.auth = null;
            };

            this.doLogout = function () {
                _this.auth.$signOut(); //v2.x.x
                _this.user = null;
            };

            this.doLogin = function () {

                var self = _this;
                var modalInstance = $uibModal.open({
                    templateUrl: 'login.html',
                    controller: 'LoginController',
                    resolve: {
                        Auth: function Auth() {
                            return self.auth;
                        }
                    }
                });

                modalInstance.result.then(function () {}, function () {});
            };

            this.doReset = function () {

                //v2.x.x
                auth.$sendPasswordResetEmail(_this.user.email, function (error) {
                    if (error === null) {
                        alert("Password reset email sent");
                    } else {
                        alert("Error sending password reset email:", error);
                    }
                });
            };
        }

    }).component('loginMenu', {

        template: ['<div class="c-login-menu">', '  <a ng-if="!$ctrl.user" ng-click="$ctrl.doLogin()">Login</a>', '  <div ng-if="$ctrl.user" class="c-login__user">', '    <small>{{$ctrl.user.email}}</small>', '    <a class="btn btn-link" ng-click="$ctrl.doReset()" title="Reset Password">', '      <span class="glyphicon glyphicon-envelope"></span>', '    </a>', '    <a class="btn btn-link" ng-click="$ctrl.doLogout()" title="Log Out">', '      <span class="glyphicon glyphicon-log-out"></span>', '    </a>', '  </div>', '</div>'].join(' '),

        controller: function controller($uibModal, $firebaseAuth) {
            var _this2 = this;

            this.$onInit = function () {
                _this2.auth = $firebaseAuth();
                _this2.auth.$onAuthStateChanged(function (authData) {
                    return _this2.user = authData;
                });
            };

            this.$onDestroy = function () {
                _this2.auth = null;
            };

            this.doLogout = function () {
                _this2.auth.$signOut(); //v2.x.x
                _this2.user = null;
            };

            this.doLogin = function () {

                var self = _this2;
                var modalInstance = $uibModal.open({
                    templateUrl: 'login.html',
                    controller: 'LoginController',
                    resolve: {
                        Auth: function Auth() {
                            return self.auth;
                        }
                    }
                });

                modalInstance.result.then(function () {}, function () {});
            };

            this.doReset = function () {

                //v2.x.x
                auth.$sendPasswordResetEmail(_this2.user.email, function (error) {
                    if (error === null) {
                        alert("Password reset email sent");
                    } else {
                        alert("Error sending password reset email:", error);
                    }
                });
            };
        }

    }).constant('Templates', ['Pure Mortal', 'Champion of God', 'Changeling', 'Emissary of Power', 'Focused Practitioner', 'Knights of a Faerie Court', 'Lycanthrope', 'Minor Talent', 'Red Court Infected', 'Sorcerer', 'True Believer', 'Were-Form', 'White Court Vampire', 'White Court Virgin', 'Wizard']).constant("CharacterShell", {

        name: "",
        template: "",
        fatePoints: 0,

        powerLevel: "",
        skillCap: 0,
        baseRefresh: 0,

        adjustedRefresh: 0,
        aspects: {
            highConcept: "",
            trouble: "",
            other: ""
        },

        stress: {
            physical: {
                0: false,
                1: false,
                2: false
            },
            mental: {
                0: false,
                1: false,
                2: false
            },
            social: {
                0: false,
                1: false,
                2: false
            },
            armor: {
                /*
                modifier: 2,
                description: ""
                */
            }
        },
        consequences: {
            /*
            "aspect": { 
                type: "mild | moderate | severe | extreme",
                modifier: 2 | 4 | 6 | 8,
                stress: "any | physical | mental | social"
            }
            */
        },
        skills: {
            total: 0,
            spent: 0,
            superb: { choices: "" },
            great: { choices: "" },
            good: { choices: "" },
            fair: { choices: "" },
            average: { choices: "" }
        },

        powers: {
            /*
            "ability": {
                cost: "number",
                misc: "string"
            }
            */
        },

        phases: {
            background: {
                events: "",
                aspect: ""
            },
            conflict: {
                events: "",
                aspect: ""
            },
            story: {
                events: "",
                aspect: "",
                title: "",
                guest: ""
            },
            guest1: {
                events: "",
                aspect: "",
                title: "",
                guest: ""
            },
            guest2: {
                events: "",
                aspect: "",
                title: "",
                guest: ""
            }
        },

        notes: ""

    });
})(angular);

(function (angular) {

    "use strict";

    angular.module('dresden', ["firebase", 'ui.router', 'ui.bootstrap', 'ngAnimate', 'dresden.common', 'dresden.home', 'dresden.char'])

    /**
     *
     */
    .config(function myAppConfig($locationProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/');
        // $locationProvider.html5Mode(true);
    });

    window.show = function (selector, btn) {
        $('.c-card').removeClass('is-shown');
        $(selector).addClass('is-shown');
        var $btn = $(btn);
        $btn.addClass('active');
        $btn.siblings().removeClass('active');
    };
})(angular);

(function (angular) {

    "use strict";

    angular.module("dresden.home", ["firebase", 'dresden.common']).config(function myAppConfig($stateProvider) {
        $stateProvider.state({
            name: 'home',
            url: '/',
            template: '<home></home>'
        });
    });
})(angular);
(function (angular) {

    "use strict";

    var HomeController = function () {
        function HomeController(DataStore, CharacterShell, $firebaseAuth, $timeout, $state) {
            'ngInject';

            _classCallCheck(this, HomeController);

            this.store = DataStore;
            this.auth = $firebaseAuth();
            this.blankChar = CharacterShell;
            this.state = $state;
        }

        _createClass(HomeController, [{
            key: '$onInit',
            value: function $onInit() {
                var _this3 = this;

                this.displayOpts = {
                    loading: false,
                    message: null,
                    error: null
                };

                var loadback = function loadback() {
                    _this3.updateList();
                    _this3.displayOpts.loading = false;
                };
                var errback = function errback(error) {
                    return _this3.displayOpts.error = "Failed to load saved data: " + error.data;
                };

                var callback = function callback(authData) {
                    _this3.user = authData;

                    if (authData && authData.uid) {
                        _this3.displayOpts.loading = true;
                        _this3.data = _this3.store.getCharsForUser(authData.uid);
                        _this3.data.$loaded().then(loadback).catch(errback);

                        // this.store.getCharsForUser(authData.uid).then( (data) => {
                        //     this.data = data;
                        //     this.updateList();
                        // }, (error) => {
                        //     this.displayOpts.error = error.data;
                        // });

                    } else if (_this3.data) {
                        _this3.data.$destroy();
                        _this3.updateList();
                    }
                };

                this.auth.$onAuthStateChanged(callback);
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.store = null;
                this.auth = null;
                this.blankChar = null;
                this.state = null;
            }
        }, {
            key: 'updateList',
            value: function updateList() {
                if (!this.user) return;

                var id = this.user.uid;
                var chars = [];

                angular.forEach(this.data, function (value, key) {
                    if (value.userId && value.userId === id) chars.push(key);
                });
                this.chars = chars;
            }
        }, {
            key: 'createCharacter',
            value: function createCharacter() {
                var _this4 = this;

                var name = prompt("Name the character", "Joe Bob");
                if (!name) {
                    alert("Characters must have a name");
                    return;
                } else if (this.data[name]) {
                    alert("Name is already in use");
                    return;
                }

                //associate user id for restricting who can edit

                var json = angular.copy(this.blankChar);
                json.userId = this.user.uid;
                json.name = name;

                this.data[name] = json;
                this.data.$save().then(function () {

                    _this4.state.go('char', { id: name });

                    // //navigate to the new char page
                    // window.location = '#/' + encodeURIComponent(name);
                }).catch(function (error) {
                    alert("Unable to create character because of an error");
                });
            }
        }, {
            key: 'removeChar',
            value: function removeChar(name) {
                var _this5 = this;

                this.data[name] = null;
                this.data.$save().then(function () {
                    _this5.updateList();
                });
            }
        }]);

        return HomeController;
    }();

    var app = angular.module("dresden.home").component("home", {
        templateUrl: 'home/home.component.html',
        controller: HomeController
    });
})(angular);
(function (angular) {

    "use strict";

    var NavController = function () {
        function NavController(DataStore2, DataStore, CharacterShell, $firebaseAuth, $timeout, $state) {
            'ngInject';

            // this.store = DataStore2;

            _classCallCheck(this, NavController);

            this.store = DataStore;
            this.auth = $firebaseAuth();
            this.blankChar = CharacterShell;
            this.state = $state;
            this.timeout = $timeout;
        }

        _createClass(NavController, [{
            key: '$onInit',
            value: function $onInit() {
                var _this6 = this;

                this.displayOpts = {
                    loading: false,
                    message: null,
                    error: null
                };

                var loadback = function loadback() {
                    _this6.updateList();
                    _this6.displayOpts.loading = false;
                };
                var errback = function errback(error) {
                    return _this6.displayOpts.error = "Failed to load saved data: " + error.data;
                };

                var callback = function callback(authData) {
                    _this6.user = authData;

                    if (authData && authData.uid) {
                        _this6.displayOpts.loading = true;
                        _this6.data = _this6.store.getCharsForUser(authData.uid);
                        _this6.data.$loaded().then(loadback).catch(errback);
                    } else if (_this6.data) {
                        _this6.displayOpts.loading = false;
                        _this6.data.$destroy();
                        _this6.updateList();
                    }
                };

                this.auth.$onAuthStateChanged(callback);
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.store = null;
                this.auth = null;
                this.blankChar = null;
                this.state = null;
            }
        }, {
            key: 'updateList',
            value: function updateList() {
                if (!this.user) return;

                var id = this.user.uid;
                var chars = [];

                angular.forEach(this.data, function (value, key) {
                    if (value.userId && value.userId === id) chars.push(key);
                });
                this.chars = chars;
            }
        }, {
            key: 'createCharacter',
            value: function createCharacter() {
                var _this7 = this;

                var name = prompt("Name the character", "Joe Bob");
                if (!name) {
                    alert("Characters must have a name");
                    return;
                } else if (this.data[name]) {
                    alert("Name is already in use");
                    return;
                }

                //associate user id for restricting who can edit

                var json = angular.copy(this.blankChar);
                json.userId = this.user.uid;
                json.name = name;

                /* DATASTORE 1 */
                this.data[name] = json;
                this.data.$save().then(function () {
                    _this7.state.go('char', { id: name });
                }).catch(function (error) {
                    alert("Unable to create character because of an error");
                });

                /* DATASTORE 2 */
                // this.store.createCharacter(this.user.uid, json);
                // this.state.go('char', {id: name});
                // this.timeout( () => {
                //     this.updateList();
                // }, 200);
            }
        }, {
            key: 'removeChar',
            value: function removeChar(name) {
                var _this8 = this;

                this.data[name] = null;
                this.data.$save().then(function () {
                    _this8.updateList();
                });
            }
        }]);

        return NavController;
    }();

    var app = angular.module("dresden.home").component("sidebar", {
        templateUrl: 'home/sidebar.component.html',
        controller: NavController
    });
})(angular);
(function (angular) {

    "use strict";

    angular.module("dresden.char", ["firebase"]).config(function myAppConfig($stateProvider) {
        $stateProvider.state({
            name: 'char',
            url: '/chars/:id',
            template: '<character></character>'
        });
    }).constant('PowerLevels', {
        "Feet in the Water": {
            skillCap: 4,
            baseRefresh: 6
        },
        "Waist Deep": {
            skillCap: 4,
            baseRefresh: 8
        },
        "Other": {
            skillCap: 5,
            baseRefresh: 10
        }
    });
})(angular);
(function (angular) {

    "use strict";

    var AspectsController = function () {
        function AspectsController() {
            _classCallCheck(this, AspectsController);

            this.editing = {};
            this.cache = {};
        }

        _createClass(AspectsController, [{
            key: '$onInit',
            value: function $onInit() {}
        }, {
            key: 'edit',
            value: function edit(aspect) {
                this.editing[aspect] = true;
                this.cache[aspect] = this.ngModel.aspects[aspect];
            }
        }, {
            key: 'saveChanges',
            value: function saveChanges(aspect) {
                this.onChange(); //trigger save
                this.editing[aspect] = false;
                this.cache[aspect] = null;
            }
        }, {
            key: 'abortChanges',
            value: function abortChanges(aspect) {
                this.editing[aspect] = false;
                this.ngModel.aspects[aspect] = this.cache[aspect];
                this.cache[aspect] = null;
            }
        }]);

        return AspectsController;
    }();

    angular.module("dresden.char").component("aspects", {
        bindings: {
            ngModel: "=",
            onChange: "&"
        },
        templateUrl: 'char/aspects.component.html',
        controller: AspectsController
    });
})(angular);
(function (angular) {

    "use strict";

    var CharController = function () {
        function CharController(DataStore2, CharacterRef, PowerLevels, Templates, $firebaseAuth, $timeout, $stateParams) {
            'ngInject';

            _classCallCheck(this, CharController);

            this.charId = $stateParams.id;
            // this.store = DataStore2;
            this.store = CharacterRef;
            this.auth = $firebaseAuth();
            this.levels = PowerLevels;
            this.templates = Templates;
            this.timeout = $timeout;
        }

        _createClass(CharController, [{
            key: '$onInit',
            value: function $onInit() {
                var _this9 = this;

                this.displayOpts = {
                    loading: false,
                    message: null,
                    error: null
                };

                var loadback = function loadback() {
                    _this9.displayOpts.loading = false;
                    _this9.refresh();
                };
                var errback = function errback(error) {
                    return _this9.displayOpts.error = "Failed to load character: " + error.data;
                };

                var callback = function callback(authData) {
                    _this9.user = authData;

                    if (authData && authData.uid) {
                        _this9.displayOpts.loading = true;
                        _this9.character = _this9.store(_this9.charId);
                        // this.character = this.store.getCharacter(authData.uid, this.charId);
                        _this9.character.$loaded().then(loadback).catch(errback);
                    } else if (_this9.character) {
                        _this9.character.$destroy();
                    }
                };

                this.auth.$onAuthStateChanged(callback);
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.charId = null;
                this.store = null;
                this.auth = null;
                this.levels = null;
                this.templates = null;
                this.timeout = null;
            }
        }, {
            key: 'refresh',
            value: function refresh() {
                var cost = 0;
                angular.forEach(this.character.powers, function (power) {
                    cost += power.cost; //NOTE: costs are negative
                });
                this.adjustedRefresh = this.character.baseRefresh + cost;
            }
        }, {
            key: 'onPowerLevelChange',
            value: function onPowerLevelChange() {
                var level = this.levels[this.character.powerLevel];
                this.character.skillCap = level.skillCap;
                this.character.baseRefresh = level.baseRefresh;
                this.refresh();
                this.save();
            }
        }, {
            key: 'save',
            value: function save() {
                var _this10 = this;

                if (this.debounce) {
                    this.timeout.cancel(this.debounce);
                    this.debounce = null;
                }

                this.debounce = this.timeout(function () {

                    _this10.debounce = null;

                    _this10.character.$save().then(function () {
                        _this10.displayOpts.showSave = true;
                        _this10.timeout(function () {
                            _this10.displayOpts.showSave = false;
                        }, 1500);
                    }, function (error) {
                        alert("There was an error");
                    });
                }, 250);
            }
        }]);

        return CharController;
    }();

    var app = angular.module("dresden.char").component("character", {
        templateUrl: 'char/char.component.html',
        controller: CharController
    });
})(angular);
(function (angular) {

    "use strict";

    var ConsequencesController = function () {
        function ConsequencesController() {
            _classCallCheck(this, ConsequencesController);
        }

        _createClass(ConsequencesController, [{
            key: '$onInit',
            value: function $onInit() {
                this.displayOpts = {};
            }
        }, {
            key: 'getConsequences',
            value: function getConsequences() {
                var result = [];
                if (this.ngModel) {
                    for (var aspect in this.ngModel) {
                        result.push(this.ngModel[aspect]);
                    }
                }
                return result.sort(function (a, b) {
                    if (a.type === b.type) return a.aspect < b.aspect;else if (a.type === 'mild') return -1;else if (b.type === 'mild') return 1;else if (a.type === 'moderate') return -1;else if (b.type === 'moderate') return 1;else if (a.type === 'severe') return -1;else if (b.type === 'severe') return 1;
                    return 0;
                });
            }
        }, {
            key: 'removeConsequence',
            value: function removeConsequence(consq) {
                if (consq) {
                    this.ngModel[consq.aspect] = null;
                    this.onChange();
                }
            }
        }, {
            key: 'showConsequenceEditor',
            value: function showConsequenceEditor() {
                this.newConsequence = {
                    aspect: "",
                    type: "mild",
                    modifier: -2
                };
                this.displayOpts.showConsequenceEditor = true;
            }
        }, {
            key: 'addConsequence',
            value: function addConsequence() {
                this.ngModel = this.ngModel || {};
                this.ngModel[this.newConsequence.aspect] = this.newConsequence;
                this.onChange();
                this.hideConquenceEditor();
            }
        }, {
            key: 'hideConquenceEditor',
            value: function hideConquenceEditor() {
                this.newConsequence = null;
                this.displayOpts.showConsequenceEditor = false;
            }
        }, {
            key: 'updateNewConsequenceModifier',
            value: function updateNewConsequenceModifier() {
                var type = this.newConsequence.type;
                var mod = 'mild' === type ? -2 : 'moderate' === type ? -4 : 'severe' === type ? -6 : -8;
                this.newConsequence.modifier = mod;
            }
        }]);

        return ConsequencesController;
    }();

    var app = angular.module("dresden.char").component("consequences", {
        bindings: {
            ngModel: "=",
            onChange: "&"
        },
        templateUrl: 'char/consequences.component.html',
        controller: ConsequencesController
    });
})(angular);
(function (angular) {

    "use strict";

    var ItemsController = function () {
        function ItemsController() {
            _classCallCheck(this, ItemsController);

            this.displayOpts = {
                editing: false
            };
        }

        _createClass(ItemsController, [{
            key: '$onInit',
            value: function $onInit() {}
        }, {
            key: 'showEditor',
            value: function showEditor() {
                this.displayOpts.editing = true;
            }
        }, {
            key: 'hideEditor',
            value: function hideEditor() {
                this.displayOpts.editing = false;
            }
        }, {
            key: 'addItem',
            value: function addItem() {
                this.ngModel = this.ngModel || {};

                //if editing existing item, remove old copy in case key (title)
                // changed. then add updated copy from editor
                if (this.editingItem) this.ngModel[this.editingItem.title] = null;

                var key = this.newItem.title;
                key = key.replace(/\'/g, '').replace(/\./g, '');

                this.ngModel[key] = this.newItem;

                this.onChange();
                this.hideEditor();
                this.newItem = {};
            }
        }, {
            key: 'removeItem',
            value: function removeItem(item) {
                if (item) {
                    this.ngModel[item.title] = null;
                    this.onChange();
                }
            }
        }, {
            key: 'editItem',
            value: function editItem(item) {
                this.displayOpts.editing = true;
                this.editingItem = item;
                this.newItem = angular.copy(item);
            }
        }]);

        return ItemsController;
    }();

    angular.module("dresden.char").component("items", {
        bindings: {
            ngModel: "=",
            onChange: "&"
        },
        templateUrl: 'char/items.component.html',
        controller: ItemsController
    });
})(angular);
(function (angular) {

    "use strict";

    var PhasesController = function () {
        function PhasesController() {
            _classCallCheck(this, PhasesController);

            this.editing = {
                background: {},
                story: {},
                conflict: {},
                guest1: {},
                guest2: {}
            };
            this.cache = {
                background: {},
                story: {},
                conflict: {},
                guest1: {},
                guest2: {}
            };
        }

        _createClass(PhasesController, [{
            key: '$onInit',
            value: function $onInit() {}
        }, {
            key: 'edit',
            value: function edit(phase, property) {
                this.editing[phase][property] = true;
                this.cache[phase][property] = this.ngModel[phase][property];
            }
        }, {
            key: 'saveChanges',
            value: function saveChanges(phase, property) {
                this.onChange(); //trigger save
                this.editing[phase][property] = false;
            }
        }, {
            key: 'abortChanges',
            value: function abortChanges(phase, property) {
                this.editing[phase][property] = false;
                this.ngModel[phase][property] = this.cache[phase][property];
            }
        }]);

        return PhasesController;
    }();

    angular.module("dresden.char").component("phases", {
        bindings: {
            ngModel: "=",
            onChange: "&"
        },
        templateUrl: 'char/phases.component.html',
        controller: PhasesController
    });
})(angular);
(function (angular) {

    "use strict";

    var PowersController = function () {
        function PowersController() {
            _classCallCheck(this, PowersController);
        }

        _createClass(PowersController, [{
            key: '$onInit',
            value: function $onInit() {
                this.displayOpts = {};
            }
        }, {
            key: 'removePower',
            value: function removePower(name) {
                this.ngModel[name] = null;
                this.onChange();
            }
        }, {
            key: 'showEditor',
            value: function showEditor() {
                this.newPower = {
                    name: "",
                    cost: 0,
                    misc: ""
                };
                this.displayOpts.showEditor = true;
            }
        }, {
            key: 'addPower',
            value: function addPower() {
                this.ngModel = this.ngModel || {};
                this.ngModel[this.newPower.name] = this.newPower;
                this.onChange();
                this.hideEditor();
            }
        }, {
            key: 'hideEditor',
            value: function hideEditor() {
                this.newPower = null;
                this.displayOpts.showEditor = false;
            }
        }]);

        return PowersController;
    }();

    angular.module("dresden.char").component("powers", {
        bindings: {
            ngModel: "=",
            onChange: "&"
        },
        templateUrl: 'char/powers.component.html',
        controller: PowersController
    });
})(angular);
(function (angular) {

    "use strict";

    var SkillsController = function () {
        function SkillsController() {
            _classCallCheck(this, SkillsController);

            this.editing = {};
        }

        _createClass(SkillsController, [{
            key: '$onInit',
            value: function $onInit() {}
        }, {
            key: 'getSkillSlots',
            value: function getSkillSlots(group) {
                if (!this.ngModel || !this.ngModel[group]) return 0;
                var skills = this.ngModel[group].choices;
                if (!skills || !skills.length) return 0;
                return skills.split(',').length;
            }

            /**
             * @return true if not valid!
             */

        }, {
            key: 'validateSpent',
            value: function validateSpent() {
                if (!this.ngModel) return false;
                var spent = this.getSkillSlots('average') + this.getSkillSlots('fair') + this.getSkillSlots('good') + this.getSkillSlots('great') + this.getSkillSlots('superb');
                return spent > this.ngModel.total;
            }

            /**
             * @return true if not valid!
             */

        }, {
            key: 'validate',
            value: function validate(group) {
                if (!this.ngModel) return false;

                switch (group) {
                    case 'superb':
                        return this.getSkillSlots('superb') > this.getSkillSlots('great');
                    case 'great':
                        return this.getSkillSlots('great') > this.getSkillSlots('good');
                    case 'good':
                        return this.getSkillSlots('good') > this.getSkillSlots('fair');
                    case 'fair':
                        return this.getSkillSlots('fair') > this.getSkillSlots('average');
                }
                return false; //valid
            }
        }, {
            key: 'edit',
            value: function edit(group) {
                this.editing[group] = true;
                this.cache = this.cache || {};
                this.cache[group] = this.ngModel[group].choices;
            }
        }, {
            key: 'saveChanges',
            value: function saveChanges(group) {
                this.onChange(); //trigger save
                this.editing[group] = false;
            }
        }, {
            key: 'abortChanges',
            value: function abortChanges(group) {
                this.editing[group] = false;
                this.ngModel[group].choices = this.cache[group];
            }
        }]);

        return SkillsController;
    }();

    angular.module("dresden.char").component("skills", {
        bindings: {
            ngModel: "=",
            onChange: "&"
        },
        templateUrl: 'char/skills.component.html',
        controller: SkillsController
    });
})(angular);
(function (angular) {

    "use strict";

    var StressController = function () {
        function StressController() {
            _classCallCheck(this, StressController);
        }

        _createClass(StressController, [{
            key: '$onInit',
            value: function $onInit() {}
        }, {
            key: 'resetStress',
            value: function resetStress() {
                var _this11 = this;

                angular.forEach(['physical', 'mental', 'social', 'hunger'], function (type) {
                    var max = _this11.ngModel[type].threshold;
                    var used = _this11.ngModel[type].used;
                    for (var index = 0; index < max; ++index) {
                        used[index] = false;
                    }
                });
                this.onChange();
            }
        }, {
            key: 'toggleStress',
            value: function toggleStress(type, index) {
                this.ngModel[type].used[index] = !this.ngModel[type].used[index];
                this.onChange();
            }
        }]);

        return StressController;
    }();

    angular.module("dresden.char").component("stress", {
        bindings: {
            ngModel: "=",
            onChange: "&"
        },
        templateUrl: 'char/stress.component.html',
        controller: StressController
    });
})(angular);